import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";
import { State } from "../../store";
import { LOGIN_PAGE } from "../../routes";
import { goToPreviousPage } from "../../../utils/goToPreviousPage";
import { mergeSearchWithTab } from "../../../utils/myAccountTabUrl";
import useAuth from "../Login/hooks/useAuth";
import EAFeatureLock from "../shared/EAFeatureLock/EAFeatureLock";
import AddSubaccountForm from "./AddSubaccountForm";
import AddSubaccountSuccess from "./AddSubaccountSuccess";

const AddSubaccount: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn } = useAuth();
  const configuration = useSelector((state: State) => state.config.configuration);

  const [isSuccess, setIsSuccess] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const handleSuccess = () => {
    setIsSuccess(true);
  };

  const handleAddAnother = () => {
    setIsSuccess(false);
    setFormKey((prev) => prev + 1);
  };

  const handleGoToAccount = () => {
    navigate(`${LOGIN_PAGE}?${mergeSearchWithTab(location.search, "people")}`);
  };

  const handleReturnToPrevious = () => {
    goToPreviousPage(navigate, `${LOGIN_PAGE}?${mergeSearchWithTab(location.search, "people")}`);
  };

  if (!isLoggedIn) {
    return (
      <div className="add-subaccount-gate">
        <EAFeatureLock
          title="Wymagane logowanie"
          description="Aby dodać osobę do konta, musisz być zalogowany. Po zalogowaniu zostaniesz automatycznie przekierowany z powrotem."
          actionLabel="Zaloguj się"
          onAction={() => navigate(`${LOGIN_PAGE}?redirect=previousPath`)}
        />
      </div>
    );
  }

  if (!configuration.allowSubaccounts) {
    return (
      <div className="add-subaccount-gate">
        <EAFeatureLock
          title="Funkcja niedostępna"
          description="Dodawanie osób do konta nie jest dostępne. Skontaktuj się z obsługą obiektu, aby uzyskać więcej informacji."
        />
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className="add-subaccount-page">
        <AddSubaccountSuccess
          onReturnToPrevious={handleReturnToPrevious}
          onAddAnother={handleAddAnother}
          onGoToAccount={handleGoToAccount}
        />
      </div>
    );
  }

  return (
    <div className="add-subaccount-page">
      <AddSubaccountForm key={formKey} onSuccess={handleSuccess} />
    </div>
  );
};

export default AddSubaccount;
